import { select, takeLatest, call, put } from 'redux-saga/effects';

import api from 'api';

import { push } from 'connected-react-router';

import {
  selectors as paymentDataSelectors,
  types as paymentDataActionTypes,
  actions as paymentDataActions,
} from 'state/paymentData';
import {
  actions as analyticsActions,
  constants as analyticsEvents,
} from 'state/analytics';
import { selectors as authSelectors } from 'state/auth';
import { handleConfirmOrder } from 'state/order/effects';

import { actions as orderActions } from 'state/order';
import reducersUtils from 'state/utils';

import validatePaymentData from 'utils/paymentData/validators/validatePaymentData';
import { isEmpty } from 'utils/types';
import routes from 'utils/routes';
import { captureError } from 'sentry';
import { actions as appActions } from 'state/app';

import { initUserShipperAndCountrySettings } from 'state/app/effects';

function* callPut({ body, path }) {
  try {
    yield call(api.authPut, path, body);
    return true;
  } catch (e) {
    throw e;
  }
}

function* setPaymentMethod({ shipperId }) {
  const paymentMethod = yield select(paymentDataSelectors.getPaymentMethod);
  const body = { ...paymentMethod };
  yield call(callPut, {
    body,
    path: `/shipper-app/shippers/${shipperId}/payment_method/`,
  });
}

function* setFiscalInfo({ shipperId }) {
  const fiscalInfo = yield select(paymentDataSelectors.getFiscalInfo);
  const body = { ...fiscalInfo };
  yield call(callPut, {
    body,
    path: `/shipper-app/shippers/${shipperId}/fiscal_info/`,
  });
}

function* handleSubmitPaymentData() {
  const paymentData = yield select(paymentDataSelectors.getPaymentData);
  const shipperId = yield select(authSelectors.getUserShipperId);

  try {
    const { errors } = yield call(validatePaymentData, { paymentData });

    if (!isEmpty(errors)) {
      throw new Error('Error in validation', JSON.stringify(errors));
    }

    const responsePaymentMethod = yield call(setPaymentMethod, { shipperId });
    const responseFiscalInfo = yield call(setFiscalInfo, { shipperId });

    const responses = [responsePaymentMethod, responseFiscalInfo];

    if (responses.find((response) => !response)) {
      throw new Error('Error in the submit, any response is false');
    }

    yield put(appActions.updateUser());
    yield call(handleConfirmOrder);

    yield put(
      analyticsActions.sendEvent(
        analyticsEvents.paymentDataRequestPageSubmit({
          data: paymentData,
        })
      )
    );
  } catch (e) {
    console.log(e);
    yield captureError(e);
  }
}

function* handleChangeToCreditCard() {
  yield put(paymentDataActions.selectPaymentMethod({ value: 'CARD' }));
  const shipperId = yield select(authSelectors.getUserShipperId);
  const permissions = yield select(authSelectors.getUserPermissions) || [];
  const forceClassicForm = permissions.includes('core.force_classic_form');
  const showNewForm = !forceClassicForm;

  try {
    const paymentMethod = yield select(paymentDataSelectors.getPaymentMethod);
    const body = { ...paymentMethod };

    yield call(api.authPatch, `shippers/${shipperId}/`, body);
    yield call(initUserShipperAndCountrySettings);

    yield put({ type: reducersUtils.RESET_ORDER_STATE });
    yield put(orderActions.setRecurring({ isRecurring: false }));

    const newOrderRoute = showNewForm
      ? routes.newOrderCatalog
      : routes.newOrder;

    yield put(push(newOrderRoute));
  } catch (err) {
    yield console.log(err);
  }
}

export default function* () {
  yield takeLatest(
    paymentDataActionTypes.submitPaymentData$,
    handleSubmitPaymentData
  );
  yield takeLatest(
    paymentDataActionTypes.changeToCreditCard$,
    handleChangeToCreditCard
  );
}
